import React, { useEffect, useState, lazy, Suspense } from "react";
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { es } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import { Headers } from "../../layouts/headers/headers";
import { MainContent } from "../../layouts/MainContent";
import { HeadersCentral } from "../../layouts/headers-central/headers-central";

import { state, rate } from "../../utils/statusUtils";
import { getSkills, getCity, getActivity } from "../../interpreter/groupSkill";
import { getAllSubcriptionAll } from "../../interpreter/subcription";
import { reportSubscription, reportTechnician } from "../../interpreter/report";

import { PlusCircleIcon , CalendarDaysIcon , 
          UserIcon , WrenchScrewdriverIcon , 
          BuildingOfficeIcon , StarIcon ,
          CheckCircleIcon , MagnifyingGlassIcon ,
          XCircleIcon , 
        } from "@heroicons/react/24/outline";

// ✅ Lazy load del modal de usuario
const UserModal = lazy(() => import("../../components/modals/profileUser"));

const Report = () => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [isOpenCalendar, setIsOpenCalendar] = useState(false);
    const [isOpenRateTech, setIsOpenRateTech] = useState(false);
    const [isOpenStatusSubs, setIsOpenStatusSubs] = useState(false);
    const [isOpenStatusTech, setIsOpenStatusTech] = useState(false);
    const [isOpenStatusClie, setIsOpenStatusClie] = useState(false);
    const [isOpenTypeSub, setIsOpenTypeSub] = useState(false);
    const [isOpenTypeSkill, setIsOpenTypeSkill] = useState(false);
    const [isOpenTypeCityTech , setIsOpenTypeCityTech] = useState(false);
    const [isOpenTypeCityClie , setIsOpenTypeCityClie] = useState(false);
    const [isOpenTypeActivity , setIsOpenTypeActivity] = useState(false);

    let [ selectedStateSubs , setSelectedStateSubs ] = useState(state[0].value);
    let [ selectedStateTech , setSelectedStateTech ] = useState(state[0].value);
    let [ selectedRateTech  ,  setSelectedRateTech ]  = useState(rate[0].value);
    let [ selectedStateClie , setSelectedStateClie ] = useState(state[0].value);

    let [startDate        , setStartDate       ] = useState(null);
    let [endDate          , setEndDate         ] = useState(null);
    let [status           , setStatus          ] = useState(null);
    let [selectedSub      , setSelectedSub     ] = useState(null);

    const [selectedSkill    , setSelectedSkill   ] = useState(null);
    const [selectedCityTech , setSelectedCityTech] = useState(null);
    const [selectedCityClie , setSelectedCityClie] = useState(null);
    const [selectedActivity , setSelectedActivity] = useState(null);

    const [sub,     setSub] = useState([]);
    const [skill,   setSkill] = useState([]);
    const [cityTech,setCityTech] = useState([]);
    const [city,    setCity] = useState([]);
    const [activity,setActivity] = useState([]);

    let [ showResults           , setShowResults] = useState(false);
    let [ showResultsDetail     , setShowResultsDetail] = useState(false);
    let [ searchResults         , setSearchResults] = useState(false);
    let [ searchResultsDetail   , setSearchResultsDetail ] = useState(false);
    let [ showResultsTechnician , setShowResultsTechnician] = useState(false);
    let [ searchResultsTechnician , setSearchResultsTechnician] = useState(false);
    let [ showResultsClient       , setShowResultsClient] = useState(false);
    let [ searchResultsClient     , setSearchResultsClient] = useState(false);

      const userData = {
        name: "Tech User",
        email: "techuser@example.com",
        role: "Technician",
        status: "Active",
      };

      const fetchSub = async () => {
        const response  = await getAllSubcriptionAll();
        const sub = [{value:null , name: "Seleccionar"}, ...response]
        setSub(sub);
      }
      const fetchSkill = async() => {
        const response = await getSkills();
        const skill = [{id_skill:null, name:"Seleccionar"}, ...response]
        setSkill(skill);
      }
      const fetchCity = async() => {
        const response = await getCity();
        const cities = [{id_city:null , name:"Seleccionar"}, ...response];
        setCityTech(cities);
        setCity(cities);
      }
      const fetchActivity = async() => {
        const response = await getActivity();
        const activies = [{id:null , description:"Seleccionar"}, ...response];
        setActivity(activies);
      }

    useEffect(()=> {
      fetchSub();
      fetchSkill();
      fetchCity();
      fetchActivity();
    }, [])  

    const openModal = () => {
      setIsModalOpen(true);
    };

    const closeModal = () => {
      setIsModalOpen(false);
    };

    const handleSubmit = () => {
      if (!startDate && !endDate) {
        setIsOpenCalendar(false);
        return;
      }

      if (!startDate || !endDate) {
        alert("Por favor, seleccione ambas fechas");
        return;
      }

      if (startDate > endDate) {
        alert("La fecha de inicio no puede ser mayor que la fecha de fin");
        return;
      }

      const formatDate = (date) => format(date, 'yyyy-MM-dd');
      const datesToSend = {
        startDate: formatDate(startDate),
        endDate: formatDate(endDate)
      };
      //console.log('Fechas seleccionadas:', datesToSend);
      setIsOpenCalendar(false);

    }

    const handleClose = () => {
      try{
        setShowResults(false);
        setShowResultsDetail(false);
        const filters = {
          startDate: null,
          endDate: null,
          type: null,
          state: null,
          status: null
        };

        setStartDate(null);
        setEndDate(null);
        setSelectedSub(state[0].value);
        setSelectedStateSubs(state[0].value);

      }catch(err){
        console.warn('Se produjo un error en el servidor',err)
      }
    }

    const handleSuscripcionSearch = async() => {
      try {
        const filters = {
            startDate: startDate ? format(startDate, 'yyyy-MM-dd') : null,
            endDate: endDate ? format(endDate, 'yyyy-MM-dd') : null,
            type: selectedSub?.id || null,
            state: selectedStateSubs != 2  ?  selectedStateSubs : null,
            status: status ? true :  null
        };
        console.log(filters);
       
        if (filters.startDate == null && filters.endDate == null && filters.type == null && filters.state == null) {
          filters.status = false;
        } else {
          filters.status = true;
        }
        //console.log(filters)
       
        if(filters.status === false ){
          const response = await reportSubscription(filters);
          if (response.content) {
            setSearchResults(response.content);
            setShowResults(true);
          }
        }else{
          const response = await reportSubscription(filters);

          if (response.technicianData && filters) {
            setSearchResultsDetail(response.technicianData);
            setShowResultsDetail(true);
          }else{
            alert("No existen resultados");
          }
        }        
      } catch (error) {
          console.error("Error en la búsqueda:", error);
          alert("Error al realizar la búsqueda");
      }  
    };

    const handleSuscripcionSearchDetail = async() => {
      try {
          // Simulando búsqueda con los filtros seleccionados
        const filters = {
            startDate: startDate ? format(startDate, 'yyyy-MM-dd') : null,
            endDate: endDate ? format(endDate, 'yyyy-MM-dd') : null,
            type: selectedSub?.id || null,
            status: true 
        };

        const response = await reportSubscription(filters);     

        const mock = response.technicianData;;
        setShowResults(false);
        setSearchResultsDetail(mock);
        setShowResultsDetail(true);

      } catch (error) {
          console.error("Error en la búsqueda:", error);
          alert("Error al realizar la búsqueda");
      }  
    };


    const handleTechnician = async() => {
      let filters = {
        skills: selectedSkill?.id_skill || null,
        cities: selectedCityTech?.id_city || null,
        rates: selectedRateTech || null,
        status: status ? true :  null
      }
     // console.log(filters);
      
            
      if(filters.skills == null && filters.cities == null && filters.rates == null){
        alert("Faltan parametros de busqueda para los tecnicos");;
        return;
      }
      const response = await reportTechnician(filters);
      //console.log('123', response);
      const mock = response.techniciansData;
      setShowResultsTechnician(true);
      setSearchResultsTechnician(mock);
    }

    const handleCloseTech = () => {
      try{
        setShowResultsTechnician(false);
        const filters = {
          skills: null,
          cities: null,
          rates: null,
          status: null
        };
        setSelectedSkill(null);
        setSelectedCityTech(null);
        setSelectedRateTech(rate[0].value);
        setSelectedStateTech(state[0].value);

      }catch(err){
        console.warn('Se produjo un error en el servidor',err)
      }
    }

    const handleClientSearch = async() => {
      let filters = {

      }
      
      
      /*if(filters. == null && filters.cities == null && filters.rates == null){
        alert("Faltan parametros de busqueda para los tecnicos");;
        return;
      }*/

      const response = await reportTechnician(filters);
      //console.log('123', response);
      const mock = response.techniciansData;
      setShowResultsTechnician(true);
      setSearchResultsTechnician(mock);
    }

    const handleCloseClient = () => {
      try{
        setShowResultsClient(false);
        const filters = {
          cities: null,
          status: null
        };
        setSelectedSkill(null);
        setSelectedCityClie(null);
        setSelectedRateTech(rate[0].value);
        setSelectedStateClie(state[0].value);

      }catch(err){
        console.warn('Se produjo un error en el servidor',err)
      }
    }

    return (
        <div className="flex h-screen">
            {/* Sidebar */}
            <Headers />

            {/* Main Content */}
            <MainContent>
              <HeadersCentral showDropdown={showDropdown} setShowDropdown={setShowDropdown} openModal={openModal} />
              <main className="p-6 w-full">
                <h1 className="text-2xl font-bold mb-8"> Panel de Reportes</h1>
                <div className="bg-white p-7 rounded-xl shadow-xl mb-3">
                  <div className="flex items-center gap-2 mb-6">
                    <h3 className="text-lg font-semibold" >Suscripciones</h3>
                    <PlusCircleIcon className="w-5 h-5 text-white" />
                  </div>
                  <div className="flex justify-between space-x-4 font-thin">
                    <div className="relative flex-1">
                      <button
                        onClick={() => setIsOpenCalendar(!isOpenCalendar)}
                        title="Fechas"
                        className="flex items-center justify-center w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition">
                        <CalendarDaysIcon className="w-5 h-5 text-gray-600" />
                        <svg
                          className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          ></path>
                        </svg>
                      </button>

                      {isOpenCalendar && (
                        <div className="absolute z-50 mt-2 left-0 p-4 bg-white border border-gray-200 rounded-lg shadow-lg w-64">
                          <div className="mb-3">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Fecha inicio
                            </label>
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              selectsStart
                              startDate={startDate}
                              endDate={endDate}
                              locale={es}
                              dateFormat="dd/MM/yyyy"
                              className="w-full p-2 border rounded"
                              placeholderText="Seleccione fecha"
                            />
                          </div>
                          <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Fecha fin
                            </label>
                            <DatePicker
                              selected={endDate}
                              onChange={(date) => setEndDate(date)}
                              selectsEnd
                              startDate={startDate}
                              endDate={endDate}
                              minDate={startDate}
                              locale={es}
                              dateFormat="dd/MM/yyyy"
                              className="w-full p-2 border rounded"
                              placeholderText="Seleccione fecha"
                            />
                          </div>
                          <button
                            onClick={handleSubmit}
                            className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition"
                          >
                            Aplicar
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="relative flex-1">
                      <button className="flex items-center justify-center w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition"
                        onClick={() => setIsOpenTypeSub(!isOpenTypeSub)} 
                        title="Suscripcion"
                      >
                        <div className="flex items-center">    
                          <CalendarDaysIcon className="w-5 h-5 text-gray-600 mr-2" />
                        </div>
                        {selectedSub?.name || 'Seleccionar'} 
                        <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                        {isOpenTypeSub && (
                          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg">
                            {sub.map((subcriptions)=>(
                              <div
                              key={subcriptions.id} // Asegúrate que cada suscripción tenga un id único
                              className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                                selectedSub?.id === subcriptions.id ? 'bg-blue-50 text-blue-600' : ''
                              }`}
                              onClick={() => {
                                setSelectedSub(subcriptions)
                                setIsOpenTypeSub(false) }}
                            >
                              {subcriptions.name} 
                            </div>
                            ))}
                          </div>
                        )}
                      </button>
                    </div>

                    <div className="relative flex-1">
                      <button className="flex items-center justify-center w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition"
                        onClick={() => setIsOpenStatusSubs(!isOpenStatusSubs)} title="Estado"
                      >
                        <div className="flex items-center">
                        <CalendarDaysIcon className="w-5 h-5 text-gray-600 mr-2" />
                            {state.find(opt => opt.value === selectedStateSubs).name || 'Seleccionar'}
                        </div>
                          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                          </svg>
                        {isOpenStatusSubs && (
                           <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg">
                            {state.map((option)=>(
                              <div
                                key={option.value}
                                className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                                  selectedStateSubs === option.value ? 'bg-blue-50 text-blue-600' : ''
                                }`}
                                  onClick={() => {
                                    setSelectedStateSubs(option.value);
                                    setIsOpenStatusSubs(false);
                                    // Aquí puedes agregar cualquier lógica adicional al seleccionar
                                  }}>{option.name}
                              </div>
                            ))}
                           </div>
                        )}
                      </button>
                    </div>
                    <div className="relative flex-1" >
                      <button 
                        className="flex items-end justify-end w-auto bg-blue-500 py-2 px-4 rounded-full hover:bg-blue-200 transition"
                        onClick={ handleSuscripcionSearch } 

                      >
                        <div className="flex items-end">
                          <CalendarDaysIcon className="w-5 h-5 text-gray-600 mr-2" />
                        </div>
                      </button>
                    </div>    
                  </div>
                  {showResults && (
                    <div className="bg-white p-5 rounded-xl shadow-xl mt-4">
                        <h4 className="text-md font-semibold mb-4">Resultados </h4>
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre Suscripcion</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado Suscripcion</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Conteo Tecnico</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {searchResults.map((item) => (
                                        <tr key={item.id}>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.name_subs}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm ">
                                              <span className = {`inline-flex items-center px-2 py-0.5 rounded-full text-base font-medium ${
                                                item.state_TechSub === '1' ?  'bg-green-700 text-green-400' : 'bg-red-700 text-red-400'
                                              }`}>
                                                {item.state_TechSub === '1' ? 'Activa' : 'No activa'}
                                              </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.count_sub}</td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            <div className="row-start-3 flex flex-row gap-3 mt-4 justify-start">
                              <button 
                                className="flex items-end justify-center bg-blue-500 px-3 py-2 rounded-full "
                                onClick={handleSuscripcionSearchDetail}
                                >
                                <PlusCircleIcon className="w-5 h-5 text-white" title="Más detalles" />
                              </button>
                              <button 
                                className="flex items-end justify-center bg-red-500 px-3 py-2 rounded-full "
                                  onClick={handleClose}
                              >
                                <PlusCircleIcon className="w-5 h-5 text-white" title="cerrar Tabla" />
                              </button>
                            </div>
                        </div>
                    </div>
                  )}
                  {showResultsDetail && (
                    <div className="bg-white p-5 rounded-xl shadow-xl mt-4">
                        <h4 className="text-md font-semibold mb-4">Resultados </h4>
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre Suscripcion</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre Tecnico</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado Suscripcion De Tecnico</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha inicio suscripcion</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha final suscripcion</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                  {searchResultsDetail.map((subscription) => (
                                    subscription.type_report.map((tech, index) => (
                                      <tr key={`${subscription.name_sub}-${tech.fullName_technician}-${index}`}>
                                        {index === 0 && (
                                          <td 
                                            className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                                            rowSpan={subscription.type_report.length}
                                          >
                                            {subscription.name_sub}
                                          </td>
                                        )}
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                          {tech.fullName_technician}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                            tech.state_TechSub === '1' 
                                              ? 'bg-green-100 text-green-800' 
                                              : 'bg-red-100 text-red-800'
                                          }`}>
                                            {tech.state_TechSub === '1' ? 'Activa' : 'No activa'}
                                          </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                          {format(new Date(tech.startSub), 'dd/MM/yyyy')}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                          {format(new Date(tech.endSub), 'dd/MM/yyyy')}
                                        </td>
                                      </tr>
                                    ))
                                  ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="gap-3 mt-4 justify-start">
                          <button 
                            className="flex items-end justify-center bg-red-500 px-3 py-2 rounded-full "
                              onClick={handleClose}
                            >
                               <PlusCircleIcon className="w-5 h-5 text-white" title="Cerrar tablas" />
                          </button>
                        </div>
                    </div>
                  )}
                </div>
                <div className="bg-white p-7 rounded-xl shadow-xl mb-3">
                  <div className="flex items-center gap-2 mb-6">
                    <h3 className="text-lg font-semibold" >Abogados</h3>
                    <UserIcon className="w-6 h-6 text-gray-700" title="Técnico" />
                  </div>  
                    <div className="flex justify-between space-x-4 font-thin">
                      <div className="relative flex-1">
                        <button 
                          className="flex items-center justify-center w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition"
                          onClick={() => setIsOpenTypeSkill(!isOpenTypeSkill)}
                          title="Habilidad"
                        >
                          <div className="flex items-center">
                            <WrenchScrewdriverIcon className="w-5 h-5 text-gray-600 mr-2" title="Habilidad" />
                          </div>
                          { selectedSkill?.name || "Seleccionar" }
                          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                          </svg>
                          {isOpenTypeSkill && (
                            <div className="absolute z-10 w-full max-w-md mt-2 bg-white border border-gray-200 rounded-lg shadow-2xl">
                              <div className="grid grid-cols-2 gap-1 p-3">
                              { skill?.map((skills)=>(
                                <div
                                  key={skills.id_skill}
                                  title={skills.name}
                                  className={`p-2 rounded hover:bg-gray-100 transition-colors text-xs text-center truncate ${
                                    selectedSkill?.id_skill === skills.id_skill ? 'bg-blue-50 text-blue-600':''
                                  }`}
                                    onClick={()=> {
                                      setSelectedSkill(skills)
                                      setIsOpenTypeSkill(false)}}
                                >
                                  {skills.name}
                                </div>
                              ))}
                              </div>
                            </div>
                          )}
                        </button>
                      </div>
                      <div className="relative flex-1">
                        <button 
                          className="flex items-center justify-center w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition"
                          onClick={() => setIsOpenTypeCityTech( !isOpenTypeCityTech )}
                          title="Ciudad"
                        >
                          <div className="flex items-center">
                            <BuildingOfficeIcon className="w-5 h-5 text-gray-600" />
                          </div>
                          { selectedCityTech?.name || "Seleccionar" }
                          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                          </svg>
                          { isOpenTypeCityTech && (
                            <div className="absolute z-10 w-full max-w-md mt-2 bg-white border border-gray-200 rounded-lg shadow-2xl">
                              { cityTech.map((citys) => (
                                <div
                                  key = {citys.id_city}
                                  className = {`p-2 rounded hover:bg-gray-100 transition-colors text-xs text-center truncate ${
                                    selectedCityTech?.id_city === citys.id_city ? 'bg-blue-50 text-blue-600':''
                                  }`}
                                  onClick={()=> {
                                    setSelectedCityTech(citys)
                                    setIsOpenTypeCityTech(false)}}
                                > 
                                  {citys.name}
                                </div>
                              ))}
                              <div></div>
                            </div>
                          )}
                        </button>
                      </div>
                        <div className="relative flex-1">
                          <button 
                            className="flex items-center justify-center w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition"
                            onClick={() => setIsOpenRateTech(!isOpenRateTech)}
                            title="Calificacion"
                          >
                            <div className="flex items-center">
                              <StarIcon className="w-5 h-5 text-yellow-500" />
                              { rate.find(opt => opt.value === selectedRateTech).name || "Seleccionar" }
                            </div>
                            <svg 
                                className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                            </svg>
                            {isOpenRateTech && (
                              <div className="absolute z-10 w-full mt-5 bg-white border border-gray-200 rounded-xl shadow-2xl">
                                { rate.map((option)=>(
                                  <div 
                                    key={option.value}
                                    className={`px-6 cursor-pointer hover:bg-gray-100 ${
                                      selectedRateTech === option.value ? 'bg-blue-50 text-blue-600' : ''
                                    }`} 
                                      onClick={() => {
                                        setSelectedRateTech(option.value);
                                        setIsOpenRateTech(false);
                                      }}>{option.name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </button>
                        </div>
                        <div className="relative flex-1">
                          <button 
                            className="flex items-center justify-center w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition"
                            onClick={() => setIsOpenStatusTech(!isOpenStatusTech)} title="Estado"
                          >
                            <div className="flex items-center">
                              <CheckCircleIcon className="w-5 h-5 text-green-500" />
                                {state.find(opt => opt.value === selectedStateTech).name || 'Seleccionar'}
                            </div>
                              <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                              </svg>
                            {isOpenStatusTech && (
                              <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg">
                                {state.map((option)=>(
                                  <div
                                    key={option.value}
                                    className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                                      selectedStateTech === option.value ? 'bg-blue-50 text-blue-600' : ''
                                    }`}
                                      onClick={() => {
                                        setSelectedStateTech(option.value);
                                        setIsOpenStatusTech(false);
                                      }}>{option.name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </button>
                        </div>
                        <div className="relative flex-1" >
                          <button 
                            className="flex items-end justify-end w-auto bg-blue-500 py-2 px-4 rounded-full hover:bg-blue-200 transition"
                            onClick={ handleTechnician }
                          >
                          <div className="flex items-end">
                            <MagnifyingGlassIcon className="w-5 h-5 text-blue-500" />
                          </div>
                          </button>
                        </div>    
                  </div>
                </div>
                { showResultsTechnician && ( 
                    <div className="bg-white p-5 rounded-xl shadow-xl mt-4">
                        <h4 className="text-md font-semibold mb-4">Resultados </h4>
                        <div className="overflow-x-auto">
                          <table className="min-w-full divide-y divide-gray-200" >
                            <thead className="bg-gray-50">
                              <tr>
                                <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cod. </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre Tecnico </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ciudad </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Habilidades </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Calificacion </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado Cuenta </th>
                              </tr>
                            </thead>
                              <tbody className="bg-white divide-y divide-gray-200">
                                {searchResultsTechnician.map((item) => (
                                  <tr key={item.id}>
                                    <td className="px-2 py-4 whitespace-nowrap text-center text-sm text-gray-500">T-{item.id}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.name_technician}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.name_city}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.name_skills}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.rates}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-base font-medium ${
                                      item.status === '1' ? 'bg-green-300 text-qreen-400' : 'bg-red-400 text-red-600'}`}>
                                        {item.status === '1' ? 'Activa' : 'No activa'}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                          </table>
                        </div>
                        <div className="gap-3 mt-4 justify-start">
                          <button 
                            className="flex items-end justify-center bg-red-500 px-3 py-2 rounded-full "
                              onClick={handleCloseTech}
                            >
                              <XCircleIcon className="w-5 h-5 text-red-600" />
                          </button>
                        </div>
                    </div>
                )}<br/>
                 {/*<div className="bg-white p-7 rounded-xl shadow-xl mb-3">
                  <div className="flex items-center gap-2 mb-6">   items-center para alinear verticalmente 
                    <h3 className="text-lg font-semibold">Clientes</h3>  Quitamos mb-6 del h3 
                    <UserIcon className="w-5 h-5 text-gray-700" />
                  </div>
               <div className="bg-white p-7 rounded-xl shadow-xl mb-3">
                  <div className="flex items-center gap-2 mb-6">  {/* items-center para alinear verticalmente 
                    <h3 className="text-lg font-semibold">Clientes</h3>  
                    <Icon path={mdiAccountTie} size={1.5} /> 
                  </div> 
                  <div className="flex justify-between space-x-4 font-thin">
                    <div className="relative flex-1">
                      <button className="flex items-center justify-center w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition"
                            onClick={()=> setIsOpenTypeActivity(!isOpenTypeActivity)}
                            title="Actividad"
                      >
                        <div className="flex items-center">
                          <Icon path={mdiFormatListBulletedType} size={1} />
                        </div>
                        {selectedActivity?.description || "Seleccionar"}
                        <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                        {isOpenTypeActivity && (
                          <div className="absolute z-10 w-full max-w-md mt-2 bg-white border border-gray-200 rounded-lg shadow-2xl">
                            {activity.map((activitys) => (
                              <div
                                key = {activitys.id}
                                className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                                  selectedActivity === activitys.id ? 'bg-blue-50 text-blue-600' : ''
                                }`}
                                onClick={() => {
                                  setSelectedActivity(activitys);
                                  setIsOpenTypeActivity(false)
                                }}>
                                {activitys.description}
                              </div>
                            ))}
                          </div>
                        )}
                      </button>
                    </div>
                    <div className="relative flex-1">
                      <button 
                        className="flex items-center justify-center w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition"
                        onClick={() => setIsOpenTypeCityClie( !isOpenTypeCityClie )}
                        title="Ciudad"
                      >
                        <div className="flex items-center">
                          <Icon path={mdiCityVariantOutline} size={1} />
                        </div>
                        { selectedCityClie?.name || "Seleccionar" }
                        <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                        { isOpenTypeCityClie && (
                          <div className="absolute z-10 w-full max-w-md mt-2 bg-white border border-gray-200 rounded-lg shadow-2xl">
                            { city.map((citys) => (
                              <div
                                key = {citys.id_city}
                                className = {`p-2 rounded hover:bg-gray-100 transition-colors text-xs text-center truncate ${
                                  selectedCityClie?.id_city === citys.id_city ? 'bg-blue-50 text-blue-600':''
                                }`}
                                onClick={()=> {
                                  setSelectedCityClie(citys)
                                  setIsOpenTypeCityClie(false)}}
                              > 
                                {citys.name}
                              </div>
                            ))}
                            <div>

                            </div>
                          </div>
                        )}
                      </button>
                    </div>
                    <div className="relative flex-1">
                      <button className="flex items-center justify-center w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition"
                        onClick={() => setIsOpenStatusClie(!isOpenStatusClie)} title="Estado"
                      >
                      <div className="flex items-center">
                        <Icon path={mdiCheckboxMarkedCirclePlusOutline} size={1.1} className="mr-2" />
                          {state.find(opt => opt.value === selectedStateClie).name || 'Seleccionar'}
                      </div>
                      <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                      </svg>
                        {isOpenStatusClie && (
                          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg">
                            {state.map((option)=>(
                              <div
                                key={option.value}
                                className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                                  selectedStateClie === option.value ? 'bg-blue-50 text-blue-600' : ''
                                }`}
                                  onClick={() => {
                                    setSelectedStateClie(option.value);
                                    setIsOpenStatusClie(false);
                                    // Aquí puedes agregar cualquier lógica adicional al seleccionar
                                  }}>{option.name}
                              </div>
                            ))}
                          </div>
                        )}
                      </button>
                    </div>
                    <div className="relative flex-1" >
                      <button 
                        className="flex items-end justify-end w-auto bg-blue-500 py-2 px-4 rounded-full hover:bg-blue-200 transition"
                        onClick={ handleClientSearch }
                      >
                      <div className="flex items-end">
                        <Icon path={mdiMagnify} size={1.05} title="Buscar"/>
                      </div>
                      </button>
                    </div>    
                    { showResultsClient && ( 
                    <div className="bg-white p-5 rounded-xl shadow-xl mt-4">
                        <h4 className="text-md font-semibold mb-4">Resultados </h4>
                        <div className="overflow-x-auto">
                          <table className="min-w-full divide-y divide-gray-200" >
                            <thead className="bg-gray-50">
                              <tr>
                                <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cod. </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre Tecnico </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ciudad </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Habilidades </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Calificacion </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado Cuenta </th>
                              </tr>
                            </thead>
                              <tbody className="bg-white divide-y divide-gray-200">
                                {searchResultsClient.map((item) => (
                                  <tr key={item.id}>
                                    <td className="px-2 py-4 whitespace-nowrap text-center text-sm text-gray-500">T-{item.id}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.name_technician}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.name_city}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.name_skills}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.rates}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-base font-medium ${
                                      item.status === '1' ? 'bg-green-300 text-qreen-400' : 'bg-red-400 text-red-600'}`}>
                                        {item.status === '1' ? 'Activa' : 'No activa'}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                          </table>
                        </div>
                        <div className="gap-3 mt-4 justify-start">
                          <button 
                            className="flex items-end justify-center bg-red-500 px-3 py-2 rounded-full "
                              onClick={handleCloseClient}
                            >
                              <Icon path={mdiCloseCircle} size={1} className="justify-center" color="white"  title="Cerrar Tabla" />
                          </button>
                        </div>
                  </div>
                  )}
                </div>
              </div>
             */}
            
          </main>
        </MainContent>
      {/* Modal del perfil del usuario */}
      <Suspense fallback={null}>
        {isModalOpen && <UserModal isOpen={isModalOpen} onClose={closeModal} user={userData} />}
      </Suspense>
    </div>
  );
};

export default Report;